import ComingSoon from '@Components/General/Feedback/ComingSoon'
import { DataTableSkeleton } from '@Components/General/Skeletons'
import { createFileRoute } from '@tanstack/react-router'
import { expensesQueryOptions } from '@utils/queryOptions'
import ContactDonations from '@Views/Contacts/Contacts/ContactDetails/ContactDonations'

export const Route = createFileRoute('/contacts/$contactId_/emails')({
  component: ComingSoon,
  // loader: opts =>
  //     opts.context.queryClient.ensureQueryData(
  //         expensesQueryOptions(opts.deps),
  //     ),
  // loaderDeps: ({ search }) => search,
  // pendingComponent: DataTableSkeleton,
})
